//REACT-JS
import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//EXPORT
import TableToExcel from 'react-html-table-to-excel';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';
import TemPermissao from '../../helpers/TemPermissao';

import { ROLE_COLUNA_INSTALACAO_RELATORIO_CAMPANHA, ROLE_COLUNA_PROTOCOLO_RELATORIO_CAMPANHA } from '../../store/roles';

class TableDetalheContato extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    componentDidMount() {
        
    }

    statusEnvio(status){
        if (status == "ENVIADO"){
            return( <span style={{color:"#009966"}}>Enviado</span>)
        }
        else if (status == "ENTREGUE"){
            return( <span style={{color:"#EF7800"}}>Entregue</span>)
        }
        else if (status == "ABERTO"){
            return( <span style={{color:"#0099FF"}}>Aberto</span>)
        }
        else if (status == "REJEITADO"){
            return( <span style={{color:"#C34E4E"}}>Rejeitado</span>)
        }
        else if (status == "Nao Enviado"){
            return(<td style={{color:"#C34E4E"}}>Não Enviado</td>)
        }
    }

    render() {

        const data = this.props.data; let html = "";
        const loading = this.props.loading;

        if (loading) {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results === undefined || data.results.length === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.identificador}>
                    <td>{row.identificador}</td>
                    <td>{row.nomeContato}</td>
                    <td>{row.email}</td>
                    <td>{this.statusEnvio(row.status)}</td>                 
                    <td>{row.dataHoraEnvio}</td>
                    <td>{row.tentativas}</td>
                    <td>{row.dataHoraAbertura}</td>
                    <td>{row.motivoNaoRecebimento}</td>
                    <TemPermissao permissao={ROLE_COLUNA_INSTALACAO_RELATORIO_CAMPANHA}><td>{row.instalacao}</td></TemPermissao>
                    <TemPermissao permissao={ROLE_COLUNA_PROTOCOLO_RELATORIO_CAMPANHA}><td>{row.protocolo}</td></TemPermissao>
                    <td style={{display: "none"}}>{row.cpf}</td>
                    <td style={{display: "none"}}>{row.codigo} </td>
                    <td style={{display: "none"}}>{row.endereco}</td>
                    <td style={{display: "none"}}>{row.data1}</td>
                    <td style={{display: "none"}}>{row.data2}</td>
                    <td style={{display: "none"}}>{row.valor}</td>
                    <td style={{display: "none"}}>{row.telefone}</td>
                    <td style={{display: "none"}}>{row.cidade}</td>
                    <td style={{display: "none"}}>{row.remetenteEmail}</td>
                    <td style={{display: "none"}}>{row.assunto}</td>
                    <td style={{display: "none"}}>{row.dataHoraAberturaDocumento}</td>
                </tr>                  
            );
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <div className="box-export ml-auto">Exportar dados como:
                    {this.export('excel')}
                </div>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Identificador</th>
                            <th>Nome</th>
                            <th>E-mail</th>
                            <th>Status</th>
                            <th>Data/Hora do envio</th> 
                            <th>Tentativas</th>
                            <th>Data/Hora da abertura</th>
                            <th>Motivo não recebimento</th>
                            <TemPermissao permissao={ROLE_COLUNA_INSTALACAO_RELATORIO_CAMPANHA}><th>Instalação</th></TemPermissao>
                            <TemPermissao permissao={ROLE_COLUNA_PROTOCOLO_RELATORIO_CAMPANHA}><th>Protocolo</th></TemPermissao>
                            <th style={{display: "none"}}>CPF</th> 
                            <th style={{display: "none"}}>Código </th> 
                            <th style={{display: "none"}}>Endereço</th> 
                            <th style={{display: "none"}}>Data 1</th> 
                            <th style={{display: "none"}}>Data 2</th> 
                            <th style={{display: "none"}}>Valor</th> 
                            <th style={{display: "none"}}>telefone</th> 
                            <th style={{display: "none"}}>Cidade</th>
                            <th style={{display: "none"}}>remetenteEmail</th>
                            <th style={{display: "none"}}>assunto</th>
                            <th style={{display: "none"}}>dataHoraAberturaDocumento</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>            
            </div>
        )
    }

    export(tipo){
        if(tipo == "excel"){
            return(<TableToExcel id="test-table-xls-button" className="btn-export" table="table-to-export" filename="relatorio_envio_rastreado" buttonText="Excel"/>)
        }        
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableDetalheContato));